<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import { onBeforeMount } from 'vue'
import { useStore } from 'vuex'
export default {
  name: 'App',
  setup() {
    const store = useStore()
    onBeforeMount(() => {
      store.dispatch('fetchUser')
    })
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-top: 0;
}

/* ══════════════════════════════════════════════════════
   DARK MODE — overrides globais
   Vuetify 3 aplica .v-theme--dark no .v-application
   ══════════════════════════════════════════════════════ */

/* ── CSS custom properties (QuartoPlanner e outros) ── */
.v-application.v-theme--dark {
  --page-bg:        #0d1117;
  --surface:        rgba(30, 41, 59, 0.9);
  --surface-strong: #1e293b;
  --line:           rgba(148, 163, 184, 0.12);
  --navy:           #93c5fd;
  --navy-deep:      #bfdbfe;
  --sky:            #1e3a5f;
  --ink:            #e2e8f0;
  --muted:          #94a3b8;
  --danger:         #f87171;
  color-scheme: dark;
}

/* ── Fundo da página ── */
.v-application.v-theme--dark .bg-grey-lighten-4,
.v-application.v-theme--dark .bg-grey-lighten-3,
.v-application.v-theme--dark .bg-grey-lighten-5 {
  background-color: #0f172a !important;
}

/* ── QuartoPlanner ── */
.v-application.v-theme--dark .quarto-page {
  background:
    radial-gradient(circle at top left, rgba(44,104,197,0.1), transparent 32%),
    linear-gradient(180deg, #0d1117 0%, #0f172a 100%) !important;
}

/* ── ListarInscritosRetiro — stat cards ── */
.v-application.v-theme--dark .stat-card {
  background: #1e293b !important;
  border-color: #334155 !important;
  color: #e2e8f0 !important;
}
.v-application.v-theme--dark .stat-card--danger,
.v-application.v-theme--dark .stat-card--locked {
  background: linear-gradient(135deg, #3b1219, #1e293b) !important;
  border-color: #7f1d1d !important;
}

/* ── ListarInscritosRetiro — tabela ── */
.v-application.v-theme--dark .inscritos-table .v-data-table__tr:hover td {
  background-color: #1e3a5f !important;
}
.v-application.v-theme--dark .inscritos-table thead th {
  background-color: #0f172a !important;
  color: #64748b !important;
  border-bottom: 1px solid #1e293b !important;
}
.v-application.v-theme--dark .inscritos-table td {
  border-bottom: 1px solid #1e293b !important;
  color: #e2e8f0 !important;
}
.v-application.v-theme--dark .inscritos-table .v-data-table__td {
  color: #e2e8f0 !important;
}
.v-application.v-theme--dark .border-b {
  border-bottom-color: #1e293b !important;
}
.v-application.v-theme--dark .comprovante-box {
  border-color: #334155 !important;
}

/* ── TelaInicial ── */
.v-application.v-theme--dark .home-header {
  background: linear-gradient(135deg, #070d1a 0%, #0f1c35 100%) !important;
}
.v-application.v-theme--dark .quick-card {
  background: #1e293b !important;
  border-color: #334155 !important;
  color: #e2e8f0 !important;
}
.v-application.v-theme--dark .quick-label { color: #f1f5f9 !important; }
.v-application.v-theme--dark .quick-desc  { color: #94a3b8 !important; }
.v-application.v-theme--dark .quick-arrow { color: #475569 !important; }

/* ── Inputs e labels ── */
.v-application.v-theme--dark .v-field {
  background: #1e293b !important;
}
.v-application.v-theme--dark .v-field__input {
  color: #e2e8f0 !important;
}
.v-application.v-theme--dark .v-label {
  color: #94a3b8 !important;
}
.v-application.v-theme--dark .v-select__selection-text {
  color: #e2e8f0 !important;
}

/* ── Texto que some ── */
.v-application.v-theme--dark .text-grey-darken-3,
.v-application.v-theme--dark .text-grey-darken-2,
.v-application.v-theme--dark .text-grey {
  color: #94a3b8 !important;
}

/* ── Painéis e seções brancas genéricas ── */
.v-application.v-theme--dark .section-card,
.v-application.v-theme--dark .panel-card,
.v-application.v-theme--dark .filter-bar,
.v-application.v-theme--dark .filter-section {
  background: #1e293b !important;
  border-color: #334155 !important;
}

/* ── Classes Vuetify de cor branca/cinza que não adaptam ── */
.v-application.v-theme--dark .bg-white {
  background-color: #1e293b !important;
}
.v-application.v-theme--dark .bg-grey-lighten-4,
.v-application.v-theme--dark .bg-grey-lighten-3,
.v-application.v-theme--dark .bg-grey-lighten-5,
.v-application.v-theme--dark .min-vh-100 {
  background-color: #0f172a !important;
}

/* ── v-data-table geral ── */
.v-application.v-theme--dark .v-data-table,
.v-application.v-theme--dark .v-data-table-server {
  background-color: #1e293b !important;
}
.v-application.v-theme--dark .v-data-table .v-data-table-header__content,
.v-application.v-theme--dark .v-data-table th {
  background-color: #0f172a !important;
  color: #64748b !important;
}
.v-application.v-theme--dark .v-data-table td {
  color: #cbd5e1 !important;
  border-bottom-color: #1e293b !important;
}
.v-application.v-theme--dark .v-data-table tr:hover td {
  background-color: #1e3a5f !important;
}
</style>
